module.exports = __webpack_public_path__ + "static/media/footer_red.d17519ba.png";